import { getAuth, updatePassword } from "firebase/auth";

const changePassword = (newPassword: string) => {
    const auth = getAuth();
    const user = auth.currentUser;

    // Shouldn't be invoked when the user is not authenticated.
    return updatePassword(user!, newPassword);
};

export default changePassword;
